









































































































import { apiService, AppConstants, inActiveService, Interfaces, Models, Utils } from "@/core/Export";
import store from "@/store";
import VueCordovaDevice from "vue-cordova-device";
import { Component, Vue } from "vue-property-decorator";
Vue.use(VueCordovaDevice);
@Component({
  components: {},
})
export default class LoginPage extends Vue {
  customerCode: string;
  userName: string;
  userPassword: string;
  rememberMe: boolean;
  isFirstLoginDialogVisible: boolean;
  userNewLoginPassword: string;
  userNewLoginPasswordVerify: string;
  currentScreen: string;
  strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  isUseStrongPW: boolean;

  constructor() {
    super();
    this.customerCode = null;
    this.rememberMe = false;
    this.userName = null;
    this.userPassword = null;
    this.isFirstLoginDialogVisible = false;
    this.userNewLoginPassword = null;
    this.userNewLoginPasswordVerify = null;
    this.currentScreen = "login";
    this.isUseStrongPW = false;
    document.addEventListener("deviceready", this.onDeviceReady, false);
  }

  created() {
    this.onSetModelFromLocalStorage();
  }

  onDeviceReady() {
    let windowAny = window as any;
    this.appEnv.device = windowAny.device;
    setTimeout(() => {
      //DO NOT CHANGE THIS TIMEOUT!!!!!
      windowAny.StatusBar.backgroundColorByHexString('#17396f');
    }, 3100);

    this.appEnv.initializeFireBase();
    this.onSetModelFromLocalStorage();
  }

  onChangeScreen(screenType: string) {
    if (screenType == "resetPassword") {
    }
    this.currentScreen = screenType;
  }

  onLogin(e) {
    e.preventDefault();
    let loginForm = this.$refs.loginForm as any;
    loginForm.validate().then((success) => {
      if (success) {
        this.login();
      }
    });
  }

  async login() {
    if (this.rememberMe) {
      this.appEnv.appStorage.persist("userName", this.userName);
      this.appEnv.appStorage.persist("customerCode", this.customerCode);
      if (this.appEnv.IsMobileApp) {
        this.appEnv.appStorage.persist("userPassword", this.userPassword);
      }
    }

    await this.appEnv.onCheckApiUrlByCustomerCode(this.customerCode);

    this.appEnv.isBusy = true;
    this.appEnv.customerCode = this.customerCode;
    apiService
      .login(this.customerCode, this.userName, this.userPassword)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {

          let infoMsgs = [];
          if (call.msgs && call.msgs.msgs) {
            infoMsgs = (call.msgs.msgs as any[]).filter((x) => x.msgLevel == 0).map((x) => { return { message: x.message }; });
          }

          if (infoMsgs.length)
            this.appEnv.showInfoDialog(infoMsgs).then(() => this.onSuccessfullyLogin(call));
          else
            this.onSuccessfullyLogin(call);

        } else {
          this.appEnv.showErrorDialog([{ message: call.msgs.msgs[0].message }]);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.showErrorDialog([{ message: this.$t("msgs.userOrPasswordError") }]);
        this.appEnv.isBusy = false;
      });
  }

  onSuccessfullyLogin(call) {

    let userInfo = call.callResult.userInfo as Models.UserInfo;
    if (userInfo.isFirstLogin) {
      this.isFirstLoginDialogVisible = true;
      this.isUseStrongPW = userInfo.isUseStrongPW;
    } else {
      this.appEnv.login(call.callResult.userInfo);
    }
    if (userInfo.minutesToTerminateSessionAfterWithoutUsingSystem > 0) {
      inActiveService.startTimer(userInfo.minutesToTerminateSessionAfterWithoutUsingSystem, this.appEnv.isDevEnv);
    }
  }

  async onResetPassword(e) {
    e.preventDefault();

    await this.appEnv.onCheckApiUrlByCustomerCode(this.customerCode);

    let resetPasswordForm = this.$refs.resetPasswordForm as any;
    resetPasswordForm.validate().then((success) => {
      if (success) {
        this.appEnv.customerCode = this.customerCode;
        this.appEnv.isBusy = true;
        apiService
          .userPasswordReset(this.userName, this.customerCode)
          .then((res) => {
            let result = res as Interfaces.iServiceRequest;
            let call = result.calls[0] as Interfaces.iServiceCall;
            let msg = call.msgs.msgs[0].message;
            if (call && call.isSuccess) {
              Utils.Notification.notifyPositive(msg, "check_circle", "bottom", 7000);
            } else {
              Utils.Notification.notifyNegative(msg);
            }
          })
          .catch((err) => {
          })
          .finally(() => {
            this.appEnv.isBusy = false;
          })
      }
    });
  }

  async onChangeUserPassword(e) {
    e.preventDefault();

    this.appEnv.onCheckApiUrlByCustomerCode(this.customerCode);

    let userPasswordChangeForm = this.$refs.userPasswordChangeForm as any;
    userPasswordChangeForm.validate().then((success) => {
      if (success) {
        this.appEnv.isBusy = true;
        apiService
          .userPasswordChangeFromLogin(
            this.userName,
            this.userNewLoginPassword,
            this.userNewLoginPasswordVerify
          )
          .then((res) => {
            let result: Interfaces.iServiceRequest = res;
            let call = result.calls[0] as Interfaces.iServiceCall;
            if (call && call.isSuccess) {
              this.userPassword = this.userNewLoginPassword;
              this.isFirstLoginDialogVisible = false;
              this.login();
            } else {
              this.appEnv.showErrorDialog([{ message: call.msgs.msgs[0].message }]);
            }
            this.appEnv.isBusy = false;
          })
          .catch((err) => {
            this.appEnv.isBusy = false;
          });
      }
    });
  }

  onSetModelFromLocalStorage() {
    if (this.isKioskMode) {
      this.customerCode = AppConstants.CustomerCode
        ? AppConstants.CustomerCode
        : this.appEnv.appStorage.persist("customerCode", "§");
      return;
    }

    this.userName = this.appEnv.appStorage.persist("userName", "§");
    this.customerCode = AppConstants.CustomerCode
      ? AppConstants.CustomerCode
      : this.appEnv.appStorage.persist("customerCode", "§");
    if (this.appEnv.IsMobileApp) {
      this.userPassword = this.appEnv.appStorage.persist("userPassword", "§");
    }
    if (this.userName || this.userPassword) {
      this.rememberMe = true;
    }
  }

  checkStrongPassword(val) {
    if (this.isUseStrongPW && !this.strongPasswordRegex.test(val)) return false;
    return true;
  }

  get isKioskMode() {
    return AppConstants.IsKioskMode;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
